module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.bde321ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dropdown-arrow.svg
// module id = 1088
// module chunks = 1